import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "collapse-title" }

import { ref, withDefaults, useSlots } from 'vue';

  export interface IProps {
    title?: string;
    modelValue?: boolean;
    collapseIcon?: string;
    borderInContainer?: boolean;
    borderColor?: string;
  }
  export interface IEmits {
    (event: 'update:modelValue', modelValue: boolean): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: '' },
    modelValue: { type: Boolean },
    collapseIcon: { default: require('@/assets/icon/reduce-gray.png') },
    borderInContainer: { type: Boolean },
    borderColor: { default: '#dddddd' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

_useCssVars(_ctx => ({
  "1c0aa6fd": (__props.borderColor)
}))

  
  
  const slots = useSlots();

  const visible = ref(false);

  const handleToggle = () => {
    visible.value = !visible.value;
    emits('update:modelValue', visible.value);
  };


return (_ctx: any,_cache: any) => {
  const _component_b_collapse = _resolveComponent("b-collapse")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ visible: visible.value, borderInContainer: __props.borderInContainer }, "component-collapse"])
  }, [
    (_unref(slots).trigger)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "trigger-container",
          onClick: handleToggle
        }, [
          _renderSlot(_ctx.$slots, "trigger", { visible: visible.value })
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "collapse-trigger",
          onClick: handleToggle
        }, [
          _withDirectives(_createElementVNode("img", {
            class: "icon icon-add",
            src: require('@/assets/icon/add.png')
          }, null, 8, _hoisted_1), [
            [_vShow, !visible.value]
          ]),
          _withDirectives(_createElementVNode("img", {
            class: "icon icon-reduce",
            src: __props.collapseIcon
          }, null, 8, _hoisted_2), [
            [_vShow, visible.value]
          ]),
          _renderSlot(_ctx.$slots, "title", { visible: visible.value }, () => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
          ])
        ])),
    _createVNode(_component_b_collapse, {
      class: "collapse-content",
      visible: visible.value
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["visible"])
  ], 2))
}
}

})